<template>
  <NavbarTop />
  <div class="content">
    <router-view />
  </div>
  <NavbarBottom />
</template>

<script>
import NavbarTop from "./components/NavbarTop.vue";
import NavbarBottom from "./components/NavbatBottom.vue";

export default {
  components: {
    NavbarTop,
    NavbarBottom,
  },
};
</script>

<style>
.content {
  width: 90%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  margin-top: 100px;
}

@media screen and (max-width: 825px) {
  .content {
    margin-bottom: 110px;
    margin-top: 10px;
  }
}
</style>
